// extracted by mini-css-extract-plugin
export var root = "Blog-module--root--NQlAZ";
export var category = "Blog-module--category--bc0Eg";
export var title = "Blog-module--title--D31uW";
export var imageContainer = "Blog-module--imageContainer--PigGv";
export var footerContainer = "Blog-module--footerContainer--SpV4k";
export var socialMediaListContainer = "Blog-module--socialMediaListContainer---hCAS";
export var socialMediaIconContainer = "Blog-module--socialMediaIconContainer--Mkh6W";